import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function LightModeIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 2.75V4.25M17.25 6.75L16.0659 7.93417M21.25 12.0001H19.75M17.25 17.2501L16.0659 16.066M12 19.75V21.25M7.9341 16.0659L6.74996 17.25M4.25 12.0001H2.75M7.93405 7.93423L6.74991 6.75003M15.25 12C15.25 13.7949 13.7949 15.25 12 15.25C10.2051 15.25 8.75 13.7949 8.75 12C8.75 10.2051 10.2051 8.75 12 8.75C13.7949 8.75 15.25 10.2051 15.25 12Z"
        stroke="#B2B2BD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ strokeOpacity: 1 }}
      />
    </svg>
  );
};
